<template>
	<van-swipe class="share-swipe">
	  <van-swipe-item>
	  	<span class="title"><img src="../../assets/register/hsh.png" /></span>
	    <img src="../../assets/register/bg.png" />
	    <a class="btn" v-if="isiOS" href="http://itunes.apple.com/cn/app/id1273703378?ls=1&mt=8"><img src="../../assets/register/btn.png" alt="" /></a>
	    <a class="btn" v-if="!isiOS" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.shallbuy.xiaoba.life"><img src="../../assets/register/btn.png" alt="" /></a>
	  </van-swipe-item>
	</van-swipe>
</template>

<script>
export default {
  data() {
    return {
      shareCode:'',
      isiOS: false
     
    };
  },
  created(){
　　let ua = navigator.userAgent.toLowerCase();
	if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
		this.isiOS = true;
	}else {
		this.isiOS = false;
	}
  }
};
</script>

<style lang="less">
.share-swipe {
	height: 100%;
	.van-swipe-item {
		position: relative;
		img {
			width: 100%;
			height: 100%;
			display: block;
		}
		.title{
			position: absolute;
		    top: 8%;
		    left: 0;
		    width: 43%;
		    margin-left: 28.5%;
		    text-align: center;
		    display: block;
		    z-index: 1;
		}
		.btn {
			position: absolute;
		    bottom: 10px;
		    left: 0;
		    width: 82%;
		    margin-left: 8.8%;
		    text-align: center;
		    display: block;
		    z-index: 1;
		}
	}
	.van-swipe__indicator {
		display: none;
		width: 7px;
	    height: 7px;
	    background: #fff;
	    opacity: 1;
	    box-sizing: border-box;
	    border: solid 1px #818181;
	}
	.van-swipe__indicator:not(:last-child) {
		margin-right: 18px;
	}
	.van-swipe__indicator--active {
		background: #F3878F;
		border: solid 1px #F3878F;
	}
}

</style>
